export enum ReportRenderTypeEnum {
  Regular = "Regular",
  PivotTable = "PivotTable",
  RawData = "RawData",
}
